'use strict';

var _tslib = require('./_tslib-bcbe0269.js');

var fonts = require('./fonts/fonts.js');

var base$1 = require('./base-1dde5d6e.js');

var large = _tslib.__assign(_tslib.__assign({}, base$1.large), {
  fontFamily: fonts.mono
});

var base = _tslib.__assign(_tslib.__assign({}, base$1.base), {
  fontFamily: fonts.mono
});

var small = _tslib.__assign(_tslib.__assign({}, base$1.small), {
  fontFamily: fonts.mono
});

var xsmall = _tslib.__assign(_tslib.__assign({}, base$1.xsmall), {
  fontFamily: fonts.mono
});

var mono = /*#__PURE__*/Object.freeze({
  __proto__: null,
  large: large,
  base: base,
  small: small,
  xsmall: xsmall
});
exports.base = base;
exports.large = large;
exports.mono = mono;
exports.small = small;
exports.xsmall = xsmall;